<template>
  <div class="online-indicator" :class="{'status-online': online}">
    <span class="online-indicator__status" v-if="name != undefined"></span>
    {{ name }}
  </div>
</template>

<script>
export default {
  name: "StudentIndicator",
  props: {
    student: {},
    online: {
      type: Boolean,
    }
  },
  computed: {
    name() {
      return this.student?.name;
    },
  }
}
</script>

<style scoped>

</style>
